import {DeleteRounded, EditRounded, InfoOutlined} from "@mui/icons-material";
import {AlertColor, Button, Stack} from "@mui/material";
import {ColumnActionProps} from "../../types/ColumnActionProps";
import {H5, Small} from "../Typography";
import {ITrip} from "../../types/Trip";
import {DriverFormData, IDriver} from "../../types/Driver";
import {IAddress} from "../../types/Address";
import {Alert} from "@mui/lab";
import React from "react";

const TripListColumnShape = (props: ColumnActionProps<ITrip>) => {
    const driverStatusMap = {
        'ACTIVE': "En Cours",
        'IDLE': "Publiée",
        "ORDERED": "Commandée",
        "CANCELED": "Annulée",
        "POSTPONED": "Reportée",
        "ENDED": "Terminée",
    }

    const driverStatusSeverityMap: { [key in ITrip['status']]: AlertColor } = {
        'ACTIVE': "success",
        'IDLE': "info",
        "ORDERED": "success",
        "CANCELED": "error",
        "POSTPONED": "warning",
        "ENDED": "info",
    }

    return [
        {
            Header: "Destination",
            accessor: "destinationAddress",
            minWidth: 200,
            Cell: ({value}: any) => (
                <Small>
                    {(value as IAddress).plain}
                </Small>
            ),
        },

        {
            Header: "Conducteur",
            accessor: "driver",
            minWidth: 100,
            Cell: ({value}: any) => (
                <Small>
                    {(value as IDriver).name}
                </Small>
            ),
        },

        {
            Header: "Booker",
            accessor: "bookingInfo",
            minWidth: 200,
            Cell: ({value}: any) => (
                <Small>
                    {(value as ITrip['bookingInfo'])?.bookerId}
                </Small>
            ),
        },
        {
            Header: "Date de la Course",
            accessor: "date",
            minWidth: 200,
            Cell: ({value}: any) => (
                <Small>
                    {new Date(value).toLocaleString()}
                </Small>
            ),
        },

        {
            Header: "Nombre de place",
            accessor: "numberOfSeat",
            minWidth: 100,
            Cell: ({value}: any) => (
                <Small>
                    {value || 0}
                </Small>
            ),
        },

        {
            Header: "Statut",
            accessor: "status",
            minWidth: 100,
            Cell: ({value}: any) => (
                <Alert severity={driverStatusSeverityMap[value.toUpperCase()]}
                       variant={"outlined"}
                       color={driverStatusSeverityMap[value.toUpperCase()]}
                       sx={{paddingY: 0, paddingX: 1, fontSize: 13, textTransform: "capitalize"}}>
                    {driverStatusMap[value.toUpperCase()]}
                </Alert>
            ),
        },
        {
            Header: "Création",
            accessor: "createdAt",
            minWidth: 100,
            Cell: ({value}: any) => (
                <Small>
                    {new Date(value).toDateString()}
                </Small>
            ),
        }, {
            Header: "Last Modified",
            accessor: "updatedAt",
            minWidth: 100,
            Cell: ({value}: any) => (
                <Small>
                    {new Date(value).toDateString()}
                </Small>
            ),
        },
        {
            Header: "Actions",
            accessor: "",
            minWidth: 200,
            Cell: ({row}: any) => (
                <Stack direction={"row"} alignItems={"center"}>
                    <Button variant={"text"} startIcon={<DeleteRounded/>}
                            onClick={() => props.onDeleteAction(row.original)} color={"error"}>
                        Supprimer
                    </Button>
                </Stack>
            )
        }
    ]
}

export default TripListColumnShape
